import { useMutation, gql, useLazyQuery } from "@apollo/client";

export const CREATE_QUERY = gql`
  mutation CreateQuery(
    $data: [JSON]
    $joins: [JSON]
    $database: String
    $schema: String
    $userId: String
    $userDbId: String
  ) {
    CreateQuery(
      data: $data
      joins: $joins
      database: $database
      schema: $schema
      user_id: $userId
      user_db_id: $userDbId
    ) {
      data {
        operation
        table
        columns
        conditions
        aggregations {
          fn
          columnName
          tableName
        }
        filterlist
        database
        schema
        calculated_columns {
          columnName
          formula
          tableName
          formulaColumnName {
            NormalizedName
            originalName
            dataType
          }
        }
      }
      joins {
        joinCondition {
          source
          sourceHandle
          target
          targetHandle
          id
          type
        }
        Source
        SourceTable
        SameSource
        joinType
        Destination
        DestinationTable
        SameDestination
        data
        type
      }
      database
      schema
      generatedQueries
    }
  }
`;

export const UPDATE_SAVED_QUERY = gql`
  mutation UpdateSavedQuery(
    $savedQueryId: Int!
    $userId: Int!
    $query: String
    $scenerioJson: JSON
  ) {
    updateSavedQuery(
      saved_query_id: $savedQueryId
      user_id: $userId
      query: $query
      scenerio_json: $scenerioJson
    ) {
      saved_query_id
      user_id
      user_db_id
      query_name
      query
      scenerio_json
      created_on
      updated_on
    }
  }
`;

export const GET_RECORDS_BY_COLUMN_NAME = gql`
  mutation GetRecordsByColumnName(
    $userId: String!
    $userDbId: String!
    $db_type: String
    $tableName: String!
    $columnName: String!
    $searchValue: String
    $offset: Int
    $limit: Int
  ) {
    getRecordsByColumnName(
      user_id: $userId
      user_db_id: $userDbId
      db_type: $db_type
      tableName: $tableName
      columnName: $columnName
      searchValue: $searchValue
      offset: $offset
      limit: $limit
    ) {
      key
      value
    }
  }
`;

export const RUN_QUERY = gql`
  mutation RunQuery(
    $sqlQuery: SQLQueryInput!
    $userId: Int!
    $userDbId: Int!
    $columns: [String]
    $rows: [String]
    $data: [String]
    $db_type: String!
    $isPivot: Boolean
  ) {
    runQuery(
      sqlQuery: $sqlQuery
      userId: $userId
      userDbId: $userDbId
      columns: $columns
      rows: $rows
      data: $data
      db_type: $db_type
      isPivot: $isPivot
    ) {
      success
      message
      data
    }
  }
`;
export const DOWNLOAD_QUERY = gql`
  mutation DownloadQuery(
    $sqlQuery: SQLQueryInput!
    $userId: Int!
    $userDbId: Int!
    $columns: [String]
    $rows: [String]
    $data: [String]
    $downloadType:String
    $db_type: String!
  ) {
    downloadQuery(
      sqlQuery: $sqlQuery
      userId: $userId
      userDbId: $userDbId
      db_type: $db_type
      columns: $columns
      rows: $rows
      data: $data
      downloadType:$downloadType
    ) {
      success
      message
      data
    }
  }
`;

export const GET_COLUMN_DATE_DETECTION = gql`
  query GetColumnDateDetection(
    $sqlQuery: SQLQueryInput!
    $columnName: String!
    $userId: Int!
    $userDbId: Int!
    $db_type: String!
  ) {
    getColumnDateDetection(
      sqlQuery: $sqlQuery
      columnName: $columnName
      userId: $userId
      userDbId: $userDbId
      db_type: $db_type
    ) {
      success
      message
      total_rows
      valid_yyyymmdd
      valid_yyyymm
      valid_yyyy
      valid_unix_seconds
      valid_unix_milliseconds
      isDate
      years
    }
  }
`;

export const GET_CHART_DATA = gql`
  mutation GetChartData(
    $sqlQuery: SQLQueryInput!
    $userId: Int!
    $userDbId: Int!
    $db_type: String!
    $period: String!
    $year: Int
    $xAxis: String!
    $yAxis: String!
    $columns: [String]
    $rows: [String]
    $data: [String]
  ) {
    getChartData(
      sqlQuery: $sqlQuery
      userId: $userId
      userDbId: $userDbId
      db_type: $db_type
      period: $period
      year: $year
      xAxis: $xAxis
      yAxis: $yAxis
      columns: $columns
      rows: $rows
      data: $data
    ) {
      success
      message
      data
      sql
    }
  }
`;

export const DOWNLOAD_QUERY_ASYNC = gql`
  mutation DownloadQueryAsync(
    $sqlQuery: SQLQueryInput!
    $userId: Int!
    $userDbId: Int!
    $columns: [String]
    $rows: [String]
    $data: [String]
    $downloadType: String
    $db_type: String!
    $format: String
    $tabName: String
  ) {
    downloadQueryAsync(
      sqlQuery: $sqlQuery
      userId: $userId
      userDbId: $userDbId
      db_type: $db_type
      columns: $columns
      rows: $rows
      data: $data
      downloadType: $downloadType
      format: $format
      tabName: $tabName
    ) {
      success
      message
      data {
        jobId
        status
        fileName
        estimatedTime
      }
    }
  }
`;

export const GET_CSV_JOB_STATUS = gql`
  query GetCsvJobStatus($jobId: Int!) {
    getCsvJobStatus(jobId: $jobId) {
      success
      message
      data {
        jobId
        status
        fileName
        filePath
        error
        createdAt
        updatedAt
      }
    }
  }
`;

export const ADD_SAVED_QUERY = gql`
  mutation AddSavedQuery(
    $userId: Int!
    $addSavedQueryUserDbId2: Int!
    $queryName: String!
    $query: String!
    $scenerioJson: JSON!
  ) {
    addSavedQuery(
      user_id: $userId
      user_db_id: $addSavedQueryUserDbId2
      query_name: $queryName
      query: $query
      scenerio_json: $scenerioJson
    ) {
      saved_query_id
      user_id
      user_db_id
      query_name
      query
      scenerio_json
      created_on
      updated_on
    }
  }
`;

export const GET_SAVED_QUERIES = gql`
  query GetSavedQueries($userId: Int!) {
    getSavedQueries(user_id: $userId) {
      saved_query_id
      user_id
      user_db_id
      query_name
      query
      scenerio_json
      created_on
      updated_on
      saved_query_channel
    }
  }
`;
export const GET_SHARED_SAVED_QUERIES = gql`
  query GetSharedSavedQueries($userId: Int!) {
    getSharedSavedQueries(user_id: $userId) {
      saved_query_id
      user_id
      user_db_id
      query_name
      query
      scenerio_json
      created_on
      updated_on
      saved_query_channel
    }
  }
`;

export const DELETE_SAVED_QUERY = gql`
  mutation DeleteSavedQuery($savedQueryId: Int!, $userId: Int!) {
    deleteSavedQuery(saved_query_id: $savedQueryId, user_id: $userId) {
      success
      deleted_query_id
    }
  }
`;

export const useSqlhooks = () => {
  const [mutation, { loading, error, data }] = useMutation(CREATE_QUERY);
  const [
    getRecordsMutation,
    {
      loading: getRecordsLoading,
      error: getRecordsError,
      data: getRecordsData,
    },
  ] = useMutation(GET_RECORDS_BY_COLUMN_NAME);
  const [
    runQueryMutation,
    { loading: runQueryLoading, error: runQueryError, data: runQueryData },
  ] = useMutation(RUN_QUERY);
  const [
    getChartDataMutation,
    { loading: getChartDataLoading, error: getChartDataError, data: getChartDataData },
  ] = useMutation(GET_CHART_DATA);
  const [
    getColumnDateDetectionQuery,
    { loading: getColumnDateDetectionLoading, error: getColumnDateDetectionError, data: getColumnDateDetectionData },
  ] = useLazyQuery(GET_COLUMN_DATE_DETECTION);
  const [
    downloadQueryMutation,
    { loading: downloadQueryLoading, error: downloadQueryError, data: downloadQueryData },
  ] = useMutation(DOWNLOAD_QUERY);
  const [
    addSavedQueryMutation,
    { loading: addSavedQueryLoading, error: addSavedQueryError, data: addSavedQueryData },
  ] = useMutation(ADD_SAVED_QUERY);
  const [
    getSavedQueriesQuery,
    { loading: getSavedQueriesLoading, error: getSavedQueriesError, data: getSavedQueriesData },
  ] = useLazyQuery(GET_SAVED_QUERIES);
  const [
    getSharedSavedQueriesQuery,
    { loading: getSharedSavedQueriesLoading, error: getSharedSavedQueriesError, data: getSharedSavedQueriesData },
  ] = useLazyQuery(GET_SHARED_SAVED_QUERIES);
  const [
    updateSavedQueryMutation,
    { loading: updateSavedQueryLoading, error: updateSavedQueryError, data: updateSavedQueryData },
  ] = useMutation(UPDATE_SAVED_QUERY);
  const [
    deleteSavedQueryMutation,
    { loading: deleteSavedQueryLoading, error: deleteSavedQueryError, data: deleteSavedQueryData },
  ] = useMutation(DELETE_SAVED_QUERY);

  const createQueryApi = async (dataArg, joins, database, schema, userId, userDbId) => {
    try {
      const { data } = await mutation({
        variables: { 
          data: dataArg, 
          joins, 
          database, 
          schema, 
          userId, 
          userDbId
        },
      });
      if (!data?.CreateQuery) {
        throw new Error("CreateQuery failed");
      }
      return {
        success: true,
        data: data.CreateQuery,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during CreateQuery",
      };
    }
  };

  const getRecordsByColumnNameApi = async (
    userId,
    userDbId,
    db_type,
    tableName,
    columnName,
    searchValue,
    offset = 0,
    limit
  ) => {
    try {
      const { data } = await getRecordsMutation({
        variables: {
          userId,
          userDbId,
          db_type,
          tableName,
          columnName,
          searchValue,
          offset,
          limit,
        },
      });
      if (!data?.getRecordsByColumnName) {
        throw new Error("getRecordsByColumnName failed");
      }
      return {
        success: true,
        data: data.getRecordsByColumnName,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.message || "An error occurred during getRecordsByColumnName",
      };
    }
  };

  const runQueryApi = async (sqlQuery, userId, userDbId, columns, rows, data, db_type = "snowflake", isPivot = undefined) => {
    try {
      const { data: gqlData } = await runQueryMutation({
        variables: { sqlQuery, userId, userDbId, columns, rows, data, db_type, isPivot },
      });
      if (!gqlData?.runQuery) {
        throw new Error("runQuery failed");
      }
      return {
        success: gqlData.runQuery.success,
        message: gqlData.runQuery.message,
        data: gqlData.runQuery.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during runQuery",
      };
    }
  };

  const getColumnDateDetectionApi = async (sqlQuery, columnName, userId, userDbId, db_type) => {
    try {
      const { data: gqlData } = await getColumnDateDetectionQuery({
        variables: {
          sqlQuery,
          columnName: String(columnName || "").trim(),
          userId: Number(userId),
          userDbId: Number(userDbId),
          db_type: db_type || "snowflake",
        },
        fetchPolicy: "network-only",
      });
      if (!gqlData?.getColumnDateDetection) {
        throw new Error("getColumnDateDetection failed");
      }
      const res = gqlData.getColumnDateDetection;
      return {
        success: res.success,
        message: res.message,
        total_rows: res.total_rows ?? 0,
        valid_yyyymmdd: res.valid_yyyymmdd ?? 0,
        valid_yyyymm: res.valid_yyyymm ?? 0,
        valid_yyyy: res.valid_yyyy ?? 0,
        valid_unix_seconds: res.valid_unix_seconds ?? 0,
        valid_unix_milliseconds: res.valid_unix_milliseconds ?? 0,
        isDate: res.isDate ?? false,
        years: Array.isArray(res.years) ? res.years : [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during getColumnDateDetection",
        total_rows: 0,
        valid_yyyymmdd: 0,
        valid_yyyymm: 0,
        valid_yyyy: 0,
        valid_unix_seconds: 0,
        valid_unix_milliseconds: 0,
        isDate: false,
        years: [],
      };
    }
  };

  const getChartDataApi = async (
    sqlQuery,
    userId,
    userDbId,
    db_type,
    period,
    year,
    xAxis,
    yAxis,
    columns = [],
    rows = [],
    data = []
  ) => {
    try {
      const { data: gqlData } = await getChartDataMutation({
        variables: {
          sqlQuery,
          userId: Number(userId),
          userDbId: Number(userDbId),
          db_type: db_type || "snowflake",
          period,
          year: year != null ? Number(year) : null,
          xAxis,
          yAxis,
          columns,
          rows,
          data,
        },
      });
      if (!gqlData?.getChartData) {
        throw new Error("getChartData failed");
      }
      return {
        success: gqlData.getChartData.success,
        message: gqlData.getChartData.message,
        data: gqlData.getChartData.data,
        sql: gqlData.getChartData.sql ?? null,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during getChartData",
        data: null,
        sql: null,
      };
    }
  };

// Download file from backend and trigger browser download
  const downloadQueryApi = async (sqlQuery, userId, userDbId, columns, rows, data, db_type = "snowflake", format = "csv",downloadType = "") => {
    try {
      const { data: gqlData } = await downloadQueryMutation({
        variables: { sqlQuery, userId, userDbId, columns, rows, data, db_type, format,downloadType },
      });
      if (!gqlData?.downloadQuery?.success) {
        throw new Error(gqlData?.downloadQuery?.message || "Download query failed");
      }
      const { fileName, minioPath } = gqlData.downloadQuery.data;
      const hostName = window.location.hostname
      const sanitizedHostName = hostName.replaceAll('.','-')

      const downloadUrl = `https://${process.env.REACT_APP_MINIO_OBJECT_END_POINT}/${sanitizedHostName}/${minioPath}`;
      // Create a temporary link to trigger download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return {
        success: true,
        message: gqlData.downloadQuery.message,
        data: gqlData.downloadQuery.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during downloadQuery",
      };
    }
  };
  const addSavedQueryApi = async (userId, userDbId, queryName, query, scenerioJson) => {
    try {
      const { data } = await addSavedQueryMutation({
        variables: { 
          userId: Number(userId), 
          addSavedQueryUserDbId2: Number(userDbId), 
          queryName, 
          query,
          scenerioJson
        },
      });
      if (!data?.addSavedQuery) {
        throw new Error("addSavedQuery failed");
      }
      return {
        success: true,
        data: data.addSavedQuery,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during addSavedQuery",
      };
    }
  };

  const getSavedQueriesApi = async (userId) => {
    try {
      const { data } = await getSavedQueriesQuery({
        variables: { userId: Number(userId) },
        fetchPolicy: "network-only",

      });
      // console.log("getSavedQueriesApi data:", data);
      if (!data?.getSavedQueries) {
        throw new Error("getSavedQueries failed");
      }
      return {
        success: true,
        data: data.getSavedQueries,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during getSavedQueries",
      };
    }
  };
  const getSharedSavedQueriesApi = async (userId) => {
    try {
      const { data } = await getSharedSavedQueriesQuery({
        variables: { userId: Number(userId) },
        fetchPolicy: "network-only",
      });
      if (!data?.getSharedSavedQueries) {
        throw new Error("getSharedSavedQueries failed");
      }
      return {
        success: true,
        data: data.getSharedSavedQueries,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during getSharedSavedQueries",
      };
    }
  };

  const updateSavedQueryApi = async (savedQueryId, userId, query, scenerioJson) => {
    try {
      const { data } = await updateSavedQueryMutation({
        variables: {
          savedQueryId: Number(savedQueryId),
          userId: Number(userId),
          query,
          scenerioJson,
        },
      });
      if (!data?.updateSavedQuery) {
        throw new Error("updateSavedQuery failed");
      }
      return {
        success: true,
        data: data.updateSavedQuery,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during updateSavedQuery",
      };
    }
  };

  const deleteSavedQueryApi = async (savedQueryId, userId) => {
    try {
      const { data } = await deleteSavedQueryMutation({
        variables: {
          savedQueryId: Number(savedQueryId),
          userId: Number(userId),
        },
      });
      if (!data?.deleteSavedQuery) {
        throw new Error("deleteSavedQuery failed");
      }
      return {
        success: data.deleteSavedQuery.success,
        deleted_query_id: data.deleteSavedQuery.deleted_query_id,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred during deleteSavedQuery",
      };
    }
  };

  return {
    createQueryApi,
    loading,
    error,
    data,
    getRecordsByColumnNameApi,
    getRecordsLoading,
    getRecordsError,
    getRecordsData,
    runQueryApi,
    runQueryLoading,
    runQueryError,
    runQueryData,
    downloadQueryApi,
    addSavedQueryApi,
    addSavedQueryLoading,
    addSavedQueryError,
    addSavedQueryData,
    getSavedQueriesApi,
    getSavedQueriesLoading,
    getSavedQueriesError,
    getSavedQueriesData,
    getSharedSavedQueriesApi,
    getSharedSavedQueriesLoading,
    getSharedSavedQueriesError,
    getSharedSavedQueriesData,
    updateSavedQueryApi,
    updateSavedQueryLoading,
    updateSavedQueryError,
    updateSavedQueryData,
    deleteSavedQueryApi,
    deleteSavedQueryLoading,
    deleteSavedQueryError,
    deleteSavedQueryData,
    getColumnDateDetectionApi,
    getColumnDateDetectionLoading,
    getChartMetadataApi: undefined,
    getChartMetadataLoading: false,
    getChartDataApi,
    getChartDataLoading,
    getChartDataError,
    getChartDataData,
  };
};
